<template>
    <div id="shop_create" class="fleet-form-main">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <div id="page-content-wrapper" class="admin-content-area">
            <template v-if="cantAccessPage === true">
                <div class="page-name">
                    <span class="page-title" id="shopHeader" v-if="$route.params.id > 0">Update Shop</span>
                    <span class="page-title" id="shopHeader" v-else>Add Shop</span>
                    <button type="submit" class="btn btn-secondary pull-right" v-on:click.prevent="BackShopList" >
                        <i class="fp-back"> </i> Back
                    </button>
                </div>
                <div class="container-fluid">
                    <div class="admin-page-content shop-crud">
                        <section class="internal-container border-top-table-fl">
                            <form autocomplete="off" class="form-horizontal basic-form-container form-custom-select" id="ShopForm">
                                <div class="form-row row-cols-md-4 row-cols-1">
                                    <div class="col form-group">
                                        <label class="control-label require" for="code">Code:</label>
                                        <input type="text" class="form-control" v-model="code" id="code" placeholder="Enter Code" name="code">
                                        <div class="field-error">{{code_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">
                                        <label class="control-label require" for="name">Name:</label>
                                        <input type="text" class="form-control" v-model="name" id="name" placeholder="Enter Shop Name" name="name">
                                        <div class="field-error">{{name_error_msg}}</div>
                                    </div>
                                    <div class="col form-group">        
                                        <label class="control-label require" for="location_id">Location:</label>
                                        <v-select v-model="location_id" name="location_id" placeholder="Select Location."
                                            label="text"
                                            :options="locationArr">
                                        </v-select>
                                        <div class="field-error">{{ location_error_msg }}</div>
                                    </div>
                                </div>
                                <div class="form-group">
                                    <div class="alert alert-warning hide offset-sm-2 col-sm-6" id="alertError">
                                        <button type="button" class="close" data-dismiss="alert" aria-label="Close"><span aria-hidden="true">&times;</span></button>
                                        <strong id="errorMsg" class="field-error"></strong>
                                    </div>
                                </div>
                                <div class="btn-groups">
                                    <button type="submit" id="createShopBtn" v-if="$route.params.id > 0" class="btn btn-primary" v-on:click.prevent="CreateShop" >
                                    <i class="fp-reload"> </i>  Update
                                    </button>
                                    <button type="submit" id="createShopBtn" v-else class="btn btn-primary" v-on:click.prevent="CreateShop" >
                                    <i class="fp-save"> </i>  Save
                                    </button>
                                    <button type="submit" id="createAndContinueShopBtn" v-if="$route.params.id == undefined" class="btn btn-tertiary" v-on:click.prevent="CreateShop(flag='Save and Continue')" >
                                    <i class="fp-save-continue"> </i>  Save and Continue
                                    </button>
                                    <button type="submit" id="cancelShopBtn" class="btn btn-tertiary" v-on:click.prevent="BackShopList" >
                                    <i class="fp-close"> </i>  Cancel
                                    </button>
                                </div>
                            </form>
                        </section>        
                    </div>
                </div>
            </template>
            <template v-else-if="cantAccessPage === false">
                <div class="container-fluid">
                    <div class="bg-white text-center">
                        <h1>
                            Oops!</h1>
                        <h2>
                            403 </h2>
                        <div class="error-details">
                            Sorry!, You don't have permission to access this page.
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <loading-content></loading-content>
            </template>
            <app-footer></app-footer>
        </div>

    </div>
</template>
<script>
import Vue from "vue";

import {commonMixins} from '../mixins/commonMixins';

import { contractMixins } from '../mixins/contractMixins';


export default {
  name: "ShopCreate",
  
  metaInfo() {
      return {title: (this.$route.params.id > 0)? "Update Shop | " +process.env.COPYRIGHT_NAME : "Create Shop | " +process.env.COPYRIGHT_NAME}
  },
  mixins:[commonMixins, contractMixins],
  data: () => ({
    name: "",
    code: "",
    location_id: null,
    locationArr: [],
    loading:false,
    permissions: [],
    cantAccessPage: "",
    name_error_msg: "",
    code_error_msg: "",
    location_error_msg: ""
  }),
  watch:{
        //check permission change
        permissions: function (permissions) {

            var self = this;
            if (permissions.length > 0) {
                for (var i = 0; i < permissions.length; i++) {
                    if (permissions[i].name == 'add_shop') {
                        self.cantAccessPage = true;
                    }
                }
            }

        }
  },
  created: function() {

  },
  mounted: function() {
        var self = this;
        self.getPermissions();
        self.loadFieldData(['location']);
         setTimeout(function () {
            var path = window.location.pathname;
            var segments = path.split("/");

            if (segments[3]) {
                self.loadShop();
            }else if(self.$route.params.import_data_error_id != undefined && self.$route.params.import_data_error_id != ''){
                self.loadInadequateShop();
            }
        }, 100);
  },
  methods: {

    BackShopList() {
      var self = this;
      self.$router.push("/shops/list");
    },

    CreateShop(flag) {
      var self = this;
      var error = false;

      self.name_error_msg = "";
      self.location_error_msg = "";
      self.code_error_msg = "";

      if (!self.name || self.name == null || self.name == "") {
        self.name_error_msg = "Name Required.";
        error = true;
      }

      if (!self.code || self.code == null || self.code == "") {
        self.code_error_msg = "Code Required.";
        error = true;
      }

      if (!self.location_id || self.location_id == null || self.location_id == "") {
        self.location_error_msg = "Location Required.";
        error = true;
      }

      if (!error) {
            self.loading = true;
            var path = window.location.pathname;
            var segments = path.split("/");
            if (segments[3])
            {
                $("#createShopBtn").val("Updating ...");
                $("#createShopBtn").prop("disabled", true);
                $("#cancelShopBtn").prop("disabled",true);
            } else {
                if (flag == "Save and Continue") {

                    $("#createAndContinueShopBtn").val("Saving ...");
                    $("#createShopBtn").prop("disabled", true);
                    $("#createAndContinueShopBtn").prop("disabled", true);
                    $("#cancelShopBtn").prop("disabled",true);

                }else{

                    $("#createShopBtn").val("Saving ...");
                    $("#createShopBtn").prop("disabled", true);
                    $("#createAndContinueShopBtn").prop("disabled", true);
                    $("#cancelShopBtn").prop("disabled",true);
                }
               
            }
            
            var fields = $("#ShopForm").serializeArray();
            fields.push({ name: "id", value: segments[3] });
            fields.push({name: "location_id", value: self.location_id.value});
            
            $.ajax({
                url: process.env.ROOT_API + "/shop/create",
                type: "POST",
                data: fields,
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createShopBtn").val("Update");
                        $("#createShopBtn").prop("disabled", false);
                        $("#cancelShopBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            $("#createAndContinueShopBtn").val("Save and Continue");
                            $("#createShopBtn").prop("disabled", false);
                            $("#createAndContinueShopBtn").prop("disabled", false);
                            $("#cancelShopBtn").prop("disabled",false);

                        }else{

                            $("#createShopBtn").val("Save");
                            $("#createShopBtn").prop("disabled", false);
                            $("#createAndContinueShopBtn").prop("disabled", false);
                            $("#cancelShopBtn").prop("disabled",false);
                        }
                    
                    }
                    if (data.status == "success") {

                        if (flag == "Save and Continue") {

                            self.name = "";  
                            self.code = "";  
                            self.location_id = null;  

                        }else{
                            self.$router.push("/shops/list");
                        }
                        
                    } else {
                        if (data.content.length > 0) {
                            var err = "";
                            for (var i = 0; i < data.content.length; i++) {
                                err += data.content[i] + "<br>";
                            }
                            $("#errorMsg").html(err);
                            $(".alert-warning").toggleClass("show");
                            setTimeout(function () {
                                $(".alert-warning").removeClass("show");
                                $(".alert-warning").addClass("hide");
                            }, 10000);
                        }
                    }
                },
                error: function (jqXHR, exception) {
                    self.loading = false;
                    if (segments[3])
                    {
                        $("#createShopBtn").val("Update");
                        $("#createShopBtn").prop("disabled", false);
                        $("#cancelShopBtn").prop("disabled",false);
                    } else {
                        if (flag == "Save and Continue") {

                            // $("#RoleForm").trigger("reset");  
                            self.name = "";  
                            $("#createAndContinueShopBtn").val("Save and Continue");
                            $("#createShopBtn").prop("disabled", false);
                            $("#createAndContinueShopBtn").prop("disabled", false);
                            $("#cancelShopBtn").prop("disabled",false);

                        }else{

                            $("#createShopBtn").val("Save");
                            $("#createShopBtn").prop("disabled", false);
                            $("#createAndContinueShopBtn").prop("disabled", false);
                            $("#cancelShopBtn").prop("disabled",false);

                        }
                    }
                    self.generateStatusCodeMessage(jqXHR,true,'shop-create')
                }
            });
      }else{
          self.errorValidationFocus();
      }
    },

    loadShop() {
        var path = window.location.pathname;
        var segments = path.split("/");
        var self = this;
        self.loading = true;
        $.ajax({
            url: process.env.ROOT_API + "/shop/" + segments[3],
            type: "GET",
            headers: this.ajxHeaders,
            dataType: "json",
            success: function (data) {
                self.loading = false;
                console.log(data);
                if (data.status == "success") {
                    
                    self.code = data.content.code;
                    self.name = data.content.name;
                    if(data.content.location_id == null){
                        self.location_id = null;
                    }else{
                        self.location_id = {value: data.content.location_id, text: self.titleCase(data.content.company_name)};
                    }
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,false,'shop-load-id')
            }
        });
    },
    loadInadequateShop() {
        var self = this;
        self.loading = true;

        $.ajax({
            url: process.env.ROOT_API + "/shop/get-inadequate-item",
            type: "GET",
            headers: this.ajxHeaders,
            crossDomain: true,
            dataType:"json",
            data:{
                inadequate_item: self.$route.params.import_data_error_id,
            },
            success: function (data) {
                self.loading = false;
                
                if (data.status == "success") {

                    self.code = data.content.code;
                    self.name = data.content.name;
                    if(data.content.location_id == null){
                        self.location_id = null;
                    }else{
                        self.location_id = {value: data.content.location_id, text: self.titleCase(data.content.company_name)};
                    }
                    self.CreateShop();
                    
                } 
            },
            error: function (jqXHR, exception) {
                self.loading = false;
                self.generateStatusCodeMessage(jqXHR,true,'shop-get-inadequate-item')
            }
        });
    }
  }
};
</script>   


// WEBPACK FOOTER //
// src/components/ShopCreate.vue